import React from "react";
import EventStore from '@stores/EventStore';
import { observer } from 'mobx-react';
import { reaction, observable } from 'mobx';
import PageHeader from '@components/PageHeader';
import PageFooter from '@components/PageFooter';
import PaymentStore from '@stores/PaymentStore';
import CustomInput from '@components/CustomInput';
import utils from '@utils/utils';
import validate from '@utils/validate';

@observer
export default class PaymentPage extends React.Component {
    @observable pageState = this.getDefaultValues();

    getDefaultValues() {
        return {
            expiration: {
                value: '',
                valid: false,
                changed: false,
                formatValue: function(value) {
                    return value.replace(/\s/g, '');
                }
            },
            number: {
                value: '',
                valid: false,
                changed: false,
                formatValue: function(value) {
                    return value.replace(/\s/g, '');
                },
                customSend: (num) => {
                    if (utils.getEncrypt()) {
                        this.sendCC();
                    } else {
                        PaymentStore.sendFormField({
                            field: 'number',
                            value: num
                        });
                    }
                }
            },
            cvv: {
                value: '',
                valid: false,
                changed: false,
                customSend: (cvv) => {
                    if (utils.getEncrypt()) {
                        this.sendCC();
                    } else {
                        PaymentStore.sendFormField({
                            field: 'cvv',
                            value: cvv
                        });
                    }
                }
            },
            zipCode: {
                value: '',
                valid: false,
                changed: false
            },
            cardName: {
                value: '',
                valid: false,
                changed: false
            },
            cardType: {
                value: 'domestic',
                changed: false
            },
            paymentAmount: {
                balanceDue: '',
                orderTotal: ''
            }
        };
    }

    sendCC = () => {
        var cc;
        if (this.pageState['number'].valid && this.pageState['cvv'].valid) {
            cc = utils.pieProtectPCI(this.pageState['number'].formatValue(this.pageState['number'].value), this.pageState['cvv'].value)
            PaymentStore.sendFormField({
                field: 'number',
                value: cc[0]
            });

            PaymentStore.sendFormField({
                field: 'cvv',
                value: cc[1]
            });
        }
    }

    idMap = {
        cardValid: 'expiration',
        cardNumber: 'number',
        cardCVC: 'cvv',
        zipCode: 'zipCode',
        cardName: 'cardName'
    }

    endReaction = reaction(() => EventStore.eventObj, () => {
        if(EventStore.eventObj.event === 'creditCardData') {
            this.pageState[EventStore.eventObj.payload.field].value = EventStore.eventObj.payload.value;
        }
        if(EventStore.eventObj.event === 'splitPayment') {
            this.pageState = this.getDefaultValues();
            this.pageState.paymentAmount.balanceDue = EventStore.eventObj.payload.balanceDue;
            this.pageState.paymentAmount.orderTotal = EventStore.eventObj.payload.orderTotal;
        }
    });

    constructor() {
        super();

        if(EventStore.eventObj.payload) {
            this.pageState.paymentAmount.balanceDue = EventStore.eventObj.payload.balanceDue;
            this.pageState.paymentAmount.orderTotal = EventStore.eventObj.payload.orderTotal;
        }

        this.handleChange = this.handleChange.bind(this);
        this.blurEventHandler = this.blurEventHandler.bind(this);
        this.handleRadioChange = this.handleRadioChange.bind(this);
    }

    handleChange(event, validator) {
        this.pageState[this.idMap[event.target.id]].value = event.target.value;
        if(typeof(validator) === 'function') {
            this.pageState[this.idMap[event.target.id]].valid = validator();
        }
        this.pageState[this.idMap[event.target.id]].changed = true;
    }

    blurEventHandler(event) {
        if(this.pageState[this.idMap[event.target.id]].valid === true && this.pageState[this.idMap[event.target.id]].changed === true) {
            if(typeof(this.pageState[this.idMap[event.target.id]].customSend) === 'function') {
                this.pageState[this.idMap[event.target.id]].customSend(this.pageState[this.idMap[event.target.id]].formatValue ? this.pageState[this.idMap[event.target.id]].formatValue(event.target.value) : event.target.value);
            } else {
                PaymentStore.sendFormField({
                    field: this.idMap[event.target.id],
                    value: this.pageState[this.idMap[event.target.id]].formatValue ? this.pageState[this.idMap[event.target.id]].formatValue(event.target.value) : event.target.value
                });
            }
            this.pageState[this.idMap[event.target.id]].changed = false;
        }
    }

    handleRadioChange(event) {
        event.stopPropagation();

        this.pageState.cardType.changed = event.target.id === this.pageState.cardType.value ? false : true;
        if(this.pageState.cardType.changed) {
            this.pageState.cardType.value = event.target.id;
            PaymentStore.sendFormField({
                field: 'cardHolderDomesticorIntType',
                value: event.target.id
            });
        }
    }

    render() {
        return (
            <div className="padding-bot-50">
                <PageHeader title="Payment Information"/>
                { (this.pageState.paymentAmount.balanceDue || this.pageState.paymentAmount.orderTotal) && 
                    <div className="padding-v-15">
                        <div className="mob-center text-center">
                            { this.pageState.paymentAmount.balanceDue &&
                                <div className="inline-block margin-right-10p">
                                    <div className="big-text red bolder">{this.pageState.paymentAmount.balanceDue}</div>
                                    <div className="bolder text-right">Payment Amount</div>
                                </div>
                            }
                            { this.pageState.paymentAmount.orderTotal && this.pageState.paymentAmount.orderTotal !== this.pageState.paymentAmount.balanceDue &&
                                <div className="inline-block">
                                    <div className="big-text red bolder">{this.pageState.paymentAmount.orderTotal}</div>
                                    <div className="bolder text-right">Total Due</div>
                                </div>
                            }
                        </div>
                    </div>
                }
                <div className="margin-bot-10">
                    <div className="mob-center">
                        <h3>CreditCard Information</h3>
                    </div>
                    <form id="ccform" onBlur={this.blurEventHandler} autoComplete="off">
                        <div className="inline-block padding-left-10 col">
                            <div className="margin-bot-15">
                                <label htmlFor="cardNumber">Card Number<abbr title="required">*</abbr></label>
                                <CustomInput id="cardNumber" 
                                    name="number" 
                                    type="password" 
                                    placeholder="CreditCard Number" 
                                    value={this.pageState[this.idMap.cardNumber].value} 
                                    onChange={this.handleChange} 
                                    ruleMessage="Please enter valid credit card." 
                                    isValid={this.pageState[this.idMap.cardNumber].valid} 
                                    validator={() => {return Payment.fns.validateCardNumber(this.pageState[this.idMap.cardNumber].value); }} 
                                    required="required" 
                                    pattern="\d*"
                                />
                            </div>
                            <div className="margin-bot-15">
                                <label htmlFor="cardName">Full Name<abbr title="required">*</abbr></label>
                                <CustomInput id="cardName" 
                                    name="name" 
                                    placeholder="Full Name" 
                                    value={this.pageState[this.idMap.cardName].value} 
                                    onChange={this.handleChange} 
                                    ruleMessage="Please enter Name." 
                                    isValid={this.pageState[this.idMap.cardName].valid} 
                                    validator={() => {return this.pageState[this.idMap.cardName].value.trim() !== ''; }} 
                                    required="required"
                                />
                            </div>
                            <div className="inline-block margin-bot-15 half-col">
                                <label htmlFor="cardValid">Valid Thru<abbr title="required">*</abbr></label>
                                <CustomInput id="cardValid" 
                                    name="expiry" 
                                    placeholder="MM/YY" 
                                    value={this.pageState[this.idMap.cardValid].value} 
                                    onChange={this.handleChange} 
                                    ruleMessage="Please enter valid expiry date." 
                                    isValid={this.pageState[this.idMap.cardValid].valid} 
                                    validator={() => { var objVal = this.pageState[this.idMap.cardValid].value.split('/'); return Payment.fns.validateCardExpiry(objVal[0], objVal[1]); }} 
                                    required="required"
                                />
                                <span className="sub-input">MM/YY</span>
                            </div>
                            <div className="inline-block margin-bot-15 half-col">
                                <label htmlFor="cardCVC">CVC<abbr title="required">*</abbr></label>
                                <CustomInput id="cardCVC" 
                                    name="cvc" 
                                    type="password" 
                                    placeholder="CVC" 
                                    value={this.pageState[this.idMap.cardCVC].value} 
                                    onChange={this.handleChange} 
                                    ruleMessage="Please enter valid CVC." 
                                    isValid={this.pageState[this.idMap.cardCVC].valid} 
                                    validator={() => {return Payment.fns.validateCardCVC(this.pageState[this.idMap.cardCVC].value, Payment.fns.cardType(this.pageState[this.idMap.cardNumber].value));}} 
                                    required="required" 
                                    autoComplete="off"
                                />
                            </div>
                            <div className="margin-bot-15 half-col">
                                <label htmlFor="zipCode">Zip Code<abbr title="required">*</abbr></label>
                                <CustomInput id="zipCode" 
                                    placeholder="Zip Code" 
                                    value={this.pageState[this.idMap.zipCode].value} 
                                    onChange={this.handleChange} 
                                    ruleMessage="Please enter valid zip code." 
                                    isValid={this.pageState[this.idMap.zipCode].valid} 
                                    validator={() => { return validate.isValidNumber(this.pageState[this.idMap.zipCode].value, 5, 5) }} 
                                    required="required" 
                                    pattern="\d*" 
                                    maxLength="5"
                                />
                            </div>
                            <div className="margin-bot-15" onChange={this.handleRadioChange} onBlur={function(event){event.stopPropagation();}}>
                                <div className="">Card Type</div>
                                <div className="inline-block"><input id="domestic" type="radio" name="cardType" value="domestic" defaultChecked={true}/><label htmlFor="domestic">Domestic</label></div>
                                <div className="inline-block"><input id="international" type="radio" name="cardType" value="international"/><label htmlFor="international">International</label></div>
                            </div>
                        </div>
                        <div id="card-container" className="inline-block padding-left-10 col">
                            
                        </div>
                    </form>
                </div>
                <PageFooter />
            </div>
        );
    }

    componentDidMount() {
        /* The crappiest hack fix ever. Couldn't figure out a way to make card api not cancel event when formatting credit number after spaces and still properly work */
        document.getElementById('cardNumber').addEventListener("change", 
            function(event){
                this.handleChange(event,() => {
                    return Payment.fns.validateCardNumber(this.pageState[this.idMap.cardNumber].value);
                })}.bind(this)
        );

        var card = new Card({
            // a selector or DOM element for the form where users will
            // be entering their information
            form: '#ccform', // *required*
            // a selector or DOM element for the container
            // where you want the card to appear
            container: '#card-container', // *required*

            // formSelectors: {
            //     numberInput: 'input#number', // optional — default input[name="number"]
            //     expiryInput: 'input#expiry', // optional — default input[name="expiry"]
            //     cvcInput: 'input#cvc', // optional — default input[name="cvc"]
            //     nameInput: 'input#name' // optional - defaults input[name="name"]
            // },

            width: document.getElementById('card-container').clientWidth-60, // optional — default 350px
            // formatting: true, // optional - default true

            // Strings for translation - optional
            // messages: {
            //     validDate: 'valid\ndate', // optional - default 'valid\nthru'
            //     monthYear: 'mm/yyyy', // optional - default 'month/year'
            // },

            // Default placeholders for rendered fields - optional
            placeholders: {
                number: '•••• •••• •••• ••••',
                name: 'Full Name',
                expiry: '••/••',
                cvc: '•••'
            },

            masks: {
                cardNumber: '•' // optional - mask card number
            },

            // if true, will log helpful messages for setting up Card
            // debug: false // optional - default false
        });
    }

    componentWillUnmount() {
        this.endReaction();
    }
}


// WEBPACK FOOTER //
// ./src/js/pages/PaymentPage.js